import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container px-5 py-4" }
const _hoisted_2 = { class: "row g-3 justify-content-center" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 text-center p-5"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = {
  key: 0,
  class: "col-12 col-lg-10"
}
const _hoisted_7 = { class: "row card light mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-header text-center" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "RESERVA")
], -1)
const _hoisted_9 = { class: "card-body row" }
const _hoisted_10 = { class: "col-12 col-lg-6 text-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h6", null, "Código", -1)
const _hoisted_12 = { class: "col-12 col-lg-6 text-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h6", null, "Estado", -1)
const _hoisted_14 = { class: "col-12 col-lg-6 text-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h6", null, "Hora", -1)
const _hoisted_16 = { class: "row card mb-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "card-header text-center" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "DATOS PERSONALES")
], -1)
const _hoisted_18 = { class: "card-body row gy-3" }
const _hoisted_19 = { class: "col-12 col-lg-12 text-center text-lg-start" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Email", -1)
const _hoisted_21 = { class: "col-12 col-lg-4 text-center text-lg-start" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Nombre y apellido", -1)
const _hoisted_23 = { class: "col-12 col-lg-4 text-center text-lg-start" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Documento", -1)
const _hoisted_25 = { class: "col-12 col-lg-4 text-center text-lg-start" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Teléfono", -1)
const _hoisted_27 = { class: "col-12 col-lg-4 text-center text-lg-start" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Dirección", -1)
const _hoisted_29 = { class: "col-12 col-lg-4 text-center text-lg-start" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Provincia", -1)
const _hoisted_31 = { class: "col-12 col-lg-4 text-center text-lg-start" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h6", { class: "text-muted" }, "Localicad", -1)
const _hoisted_33 = {
  key: 1,
  class: "col-12 text-center my-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading.status)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.loading.text), 1)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.voucher)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.codigoReserva), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("h5", null, _toDisplayString(!_ctx.voucher.cancelada ? 'Vigente' : 'Cancelada'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.turno.inicioTexto), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.email), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.nombreApellido), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.documento), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.telefono), 1)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.direccion), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.provincia), 1)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("h5", null, _toDisplayString(_ctx.voucher.localidad), 1)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.loading.text), 1)
                ]))
          ], 64))
    ])
  ]))
}